/* unplugin-vue-components disabled */import { render } from "./Header.vue?vue&type=template&id=50e7d26d&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=50e7d26d&scoped=true&lang=scss"

import exportComponent from "D:\\Develop\\Workspaces\\WeApp\\blockchain_ait_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e7d26d"]])

export default __exports__